<ng-container *ngrxLet="railVm$ as vm">
  <hr class="divider">
  <div class="body-row">
    @if (vm.showTabs || vm.isNarrowScreen) {
      <div class="tab-rail">
        @if (vm.showTabs) {
          <div class="tab-rail-tabs">
            <ng-container *ngrxLet="activeTabView$ as activeTabView">
              @if (activeTabView) {
                <alg-left-tab-bar
                  [tabs]="vm.visibleTabs"
                  [activeTab]="activeTabView.id"
                  [hasUnreadCommunityThreads]="vm.hasUnreadCommunityThreads"
                  [searchActive]="searchActive()"
                  (tabSelected)="onTabSelected($event)"
                  (searchSelected)="toggleSearch()"
                />
              }
            </ng-container>
          </div>
        }
        @if (vm.showTopRightControls && vm.isNarrowScreen) {
          <alg-top-right-controls
            class="tab-rail-controls"
            layout="rail"
            topRightMenuStyleClass="for-mobile"
            [drawLeftBorder]="false"
          />
        }
      </div>
      <hr
        class="v-divider"
        aria-hidden="true"
        [class.content-masked]="hideTree() && !searchActive()"
      >
    }
    <ng-container *ngrxLet="activeTabView$ as activeTabView">
      @if (activeTabView) {
        <div
          class="content-column alg-flex-1"
          [class.content-masked]="hideTree() && !searchActive()"
          [class.content-column-expandable]="hideTree()"
        >
          @if (searchActive()) {
            <alg-left-menu-search
              [query]="searchQuery()"
              (queryChange)="searchQuery.set($event)"
              (close)="closeSearch()"
            />
            <ng-container *ngrxLet="searchResultState$ as searchResultState">
              @if (searchResultState.isFetching) {
                <alg-loading class="alg-flex-1" />
              } @else if (searchResultState.isError) {
                <alg-error class="alg-flex-1"
                  i18n-message message="Unable to perform the search."
                  icon="ph-duotone ph-warning-circle"
                  [showRefreshButton]="true"
                  buttonCaption="Retry"
                  (refresh)="retrySearch()"
                 />
              } @else {
                <div class="alg-flex-1 scroll-wrapper">
                  <div class="scroll-container">
                    <ng-scrollbar [sensorThrottleTime]="1">
                      <alg-left-search-result [data]="searchResultState.data" />
                    </ng-scrollbar>
                  </div>
                </div>
              }
            </ng-container>
          } @else if (!hideTree()) {
            @if (isTreeTab(activeTabView.type)) {
              <alg-left-nav
                class="alg-flex-1"
                [treeIndex]="tabToTreeIndex(activeTabView.type)"
                (selectElement)="onSelectElement($event)"
              />
            } @else if (isCommunityTab(activeTabView.type)) {
              <div class="alg-flex-1 scroll-wrapper">
                <div class="scroll-container">
                  <ng-scrollbar [sensorThrottleTime]="1" orientation="vertical">
                    <alg-community-stats />
                  </ng-scrollbar>
                </div>
              </div>
            }
          }
        </div>
      }
    </ng-container>
  </div>
</ng-container>
